// extracted by mini-css-extract-plugin
module.exports = {"SrLoadingSpinner":"SrLoadingSpinner--SrLoadingSpinner--dzZnX","spin":"SrLoadingSpinner--spin--1R7oA","highlightYellowFadeIn":"SrLoadingSpinner--highlightYellowFadeIn--4wH2A"};